import React from "react";
import { FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./MenuModal.css";

export default function MenuModal({ navigationItems, onClose, onLogout, currentPath }) {
  const navigate = useNavigate();

  return (
    <div className="menu-modal">
      <button className="close-btn" onClick={onClose}>×</button>
      <div className="menu-modal-card">
        <div className="menu-modal-header">
          <h2>Quick Navigation</h2>
          <p>Open a section directly or end the current admin session.</p>
        </div>
      <div className="tiles-grid">
        {navigationItems.map((item) => (
          <div
            key={item.key}
            className={`menu-tile ${currentPath === item.path ? "active" : ""}`}
            onClick={() => {
              navigate(item.path);
              onClose();
            }}
          >
            <div className="tile-icon">{item.icon}</div>
            <div className="tile-label">{item.label}</div>
          </div>
        ))}
        <button
          type="button"
          className="menu-tile logout-tile"
          onClick={() => {
            onClose();
            onLogout();
          }}
        >
          <div className="tile-icon"><FaSignOutAlt /></div>
          <div className="tile-label">Logout</div>
        </button>
      </div>
      </div>
    </div>
  );
}
